import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { AuthEffectsEffects } from "./auth-effects.effects";
import { ConnectSignalrEffects } from "./connect-signalr.effects";

@NgModule({
    imports: [
        EffectsModule.forFeature([
            AuthEffectsEffects,
            ConnectSignalrEffects,
        ]),
    ]
})
export class PcpLiveSessionSharedEffectsModule {}
